module.exports = __webpack_public_path__ + "static/media/copy.4e0c6a11.svg";